import api from "../services/baseapi";
import axios, { AxiosRequestConfig } from "axios";
import { IApiError } from "../interfaces/IApiError";
import { ApiResponse } from "../types/ApiResponse";
import { AxiosResponse } from "axios";

export const get = async <T>(
  url: string,
  config: AxiosRequestConfig = {}
): Promise<ApiResponse<T>> => {
  try {
    // const response: any = await api.get<T>(
    //   `https://aitools.kapinsights.com/${url}`,
    //   config
    // );
    const response = await api.get<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      config
    );

    return { type: "success", data: response.data as any };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};

export const getBlob = async <T>(
  url: string,
  config: AxiosRequestConfig = {}
): Promise<
  | { type: "success"; data: T; headers?: any }
  | { type: "error"; error: IApiError }
> => {
  try {
    const response = await axios.get<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      config
    );
    return { type: "success", data: response.data, headers: response.headers };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", error: apiError };
  }
};

export const post = async <T>(
  url: string,
  data: Record<string, any> = {},
  config: AxiosRequestConfig<string> = {}
): Promise<ApiResponse<T>> => {
  try {
    // const response: any = await api.post<T>(
    //   `https://aitools.kapinsights.com/${url}`,
    //   data,
    //   config
    // );
    const response = await api.post<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      data,
      config
    );

    return { type: "success", data: response.data as any };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};

// export const postWithHeaders = async (
//   url: string,
//   data: Record<string, any> = {},
//   config: AxiosRequestConfig<string> = {}
// ): Promise<ApiResponse<{ data: Blob; headers: any }>> => {
//   try {
//     const response: AxiosResponse<Blob> = await api.post<Blob>(
//       `https://aitools.kapinsights.com/${url}`,
//       data,
//       { ...config, responseType: "blob" }
//     );
//     return {
//       type: "success",
//       data: { data: response.data, headers: response.headers },
//     };
//   } catch (error: any) {
//     const apiError: IApiError = {
//       message: error.message,
//       code: error.code,
//       response: error.response,
//     };
//     return { type: "error", data: apiError };
//   }
// };
export const postWithHeaders = async (
  url: string,
  data: Record<string, any> = {},
  config: AxiosRequestConfig<string> = {}
): Promise<
  | { type: "success"; data: Blob; headers: any }
  | { type: "error"; data: IApiError }
> => {
  try {
    // const response: AxiosResponse<Blob> = await api.post<Blob>(
    //   `https://aitools.kapinsights.com/${url}`,
    //   data,
    //   { ...config, responseType: "blob" }
    // );
    const response: AxiosResponse<Blob> = await api.post<Blob>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      data,
      { ...config, responseType: "blob" }
    );
    return {
      type: "success",
      data: response.data, // Keep the raw data
      headers: response.headers, // Expose headers at the top level
    };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};

export const put = async <T>(
  url: string,
  data: Record<string, any> = {},
  config: AxiosRequestConfig = {}
): Promise<ApiResponse<T>> => {
  try {
    // const response: any = await api.put<T>(
    //   `https://aitools.kapinsights.com/${url}`,
    //   data,
    //   config
    // );
    const response = await api.put<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      data,
      config
    );

    return { type: "success", data: response.data as any };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};

export const remove = async <T>(
  url: string,
  config: AxiosRequestConfig = {}
): Promise<ApiResponse<T>> => {
  try {
    // The DELETE request without sending data in the body
    // const response = await api.delete<T>(
    //   `https://aitools.kapinsights.com/${url}`,
    //   config
    // );
    const response = await api.delete<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      config
    );

    return { type: "success", data: response.data };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};
